<template>
  <div id="jointOrderADetail">
    <div v-if="type == 0">
        <div class="titlee">
      <div>
        {{ customerDetail.name }} |
        {{ customerDetail.phone }} |【{{customerDetail.approvalStatusName}}】
      </div>
      <div v-if="customerDetail.statusExpireTime">
        <span
          class="clock"
          v-if="
            countdown[0] / 1 != 0 ||
            countdown[1] / 1 != 0 ||
            countdown[2] / 1 != 0 ||
            countdown[3] / 1 != 0
          "
        >
          <span v-if="countdown[0]" class="theme-color">
            <van-icon name="clock-o" />
            {{ countdown[0] + "天" }}
          </span>
          <span v-else class="fail-color">
            <van-icon name="clock-o" />
            <span v-if="countdown[1]">{{ countdown[1] + "时" }}</span
            ><span v-if="countdown[2]">{{ countdown[2] + "分" }}</span
            >{{ countdown[3] + "秒" }}
          </span>
        </span>
        <!-- <span v-else>已失效</span> -->
      </div>
    </div>
    <div class="content nowarp">
      <div class="inlineB">
        <p class="colorC l">当前状态</p>
        <p class="l">
          {{ customerDetail.statusName ? customerDetail.statusName : "暂无" }}
        </p>
      </div>
      <div class="inlineB">
        <p class="colorC l">客户归属</p>
        <p class="l">
          {{ customerDetail.ownerName ? customerDetail.ownerName : "暂无" }}
        </p>
      </div>
      <div class="inlineB">
        <p class="colorC l">预计出租价格</p>
        <p class="l">
          {{
            customerDetail.expectPrice>=0 ? customerDetail.expectPrice : "暂无"
          }}元/月
        </p>
      </div>
    </div>
    <van-tabs @click="onClick" v-model="active" class="tabs" >
      <van-tab title="基本信息">
        <van-cell title="城市" :value="customerDetail.cityName || '-'" />
        <van-cell title="行政区划" :value="customerDetail.areaName || '-'" />
         <van-cell title="小区" :value="customerDetail.communityName || '-'" />
          <van-cell title="楼号" :value="customerDetail.buildingNo || '-'" />
           <van-cell title="单元号" :value="customerDetail.unitNo || '-'" />
            <van-cell title="门牌号" :value="customerDetail.roomNo || '-'" />
        <van-cell title="地址" :value="customerDetail.address || '-'" />
        <van-cell
          title="装修类型"
          :value="customerDetail.decorationTypeName || '-'"
        />
        <van-cell
          title="楼层"
          :value="`${customerDetail.floorNumber || '-'}/${
            customerDetail.totalFloor || '-'
          }`"
        />
        <van-cell title="装修前户型" :value="decorationBeforeName" />
        <van-cell title="装修后户型" :value="decorationAfterName" />
        <van-cell title="面积" :value="customerDetail.totalAcreage || '-'" >
          <template  #right-icon> 
            <span style="color:#969799">m²</span>
          </template>
        </van-cell>
         <van-cell title="有无电梯" :value="customerDetail.elevator?'有':'无'" />
        <van-cell title="备注" :value="customerDetail.remark || '-'" />
      
      </van-tab>
      <van-tab title="跟进记录">
        <van-steps
          direction="vertical"
          :active="0"
          active-color="#FD7E2D"
          active-icon="more"
          inactive-icon="checked"
        >
          <van-step
            v-for="item in customerDetail.trackRecordList || []"
            :key="item.id"
          >
            <h4>{{ `${item.statusName} 【${item.creator}】` }}</h4>
            <p>
              {{ item.content }}
              <!-- <span v-if="item.status == 103">（{{(item.takeLookDate||'').slice(0,16)}}）</span> -->
              <span v-if="item.status == 104">
                （
                <span
                  v-for="(item1, index1) in item.trackRecordReasons"
                  :key="item1.id"
                  >{{ index1 == 0 ? item1.name : "，" + item1.name }}</span
                >）
              </span>
            </p>
            <p v-if="item.remark">{{ item.remark }}</p>
            <p>{{ item.createDate }}</p>
          </van-step>
        </van-steps>
      </van-tab>
      <van-tab title="实勘">
          <!-- 房间 -->
        <template v-if="customerDetail.roomList.length">
          <van-cell
            class="house_add"
            v-for="(item, index) in customerDetail.roomList"
            :key="index"
          >
            <div class="top">
              <div class="title">
                房间<span v-if="customerDetail.roomList.length > 1">{{
                  roomNameList[index]
                }}</span>
              </div>
            </div>
            <div class="options">
              <div class="option">面积：{{ item.acreage }}m²</div>
              <div class="option" style="justify-content: center">
                朝向:{{ toWardsList[item.toward] }}
              </div>
              <van-checkbox
                class="option"
                style="justify-content: flex-end"
                v-model="item.bayWindow"
                disabled
                shape="square"
                ><span>飘窗</span></van-checkbox
              >
              <van-checkbox
                class="option"
                v-model="item.optimization"
                disabled
                shape="square"
                >优化间</van-checkbox
              >
              <van-checkbox
                class="option"
                style="justify-content: center"
                v-model="item.balcony"
                disabled
                shape="square"
                >独立阳台</van-checkbox
              >
              <van-checkbox
                class="option"
                style="justify-content: flex-end"
                v-model="item.toilet"
                disabled
                shape="square"
                >独卫</van-checkbox
              >
            </div>
            <div class="img_upload" v-if="item.fileList.length">
              <van-uploader v-model="item.fileList" :show-upload="false" />
            </div>
          </van-cell>
        </template>
         <!-- 客厅 -->
        <template v-if="customerDetail.hallList.length">
          <van-cell>
            <div
              class="house_add"
              v-for="(item, index) in customerDetail.hallList"
              :key="index"
            >
              <div class="top">
                <div class="title">
                  客厅<span v-if="customerDetail.hallList.length > 1">{{
                    roomNameList[index]
                  }}</span>
                </div>
                <div>面积：{{ item.acreage }}m²</div>
              </div>

              <div class="img_upload" v-if="item.fileList.length">
                <van-uploader v-model="item.fileList" :show-upload="false" />
              </div>
            </div>
          </van-cell>
        </template>
        <!-- 卫生间 -->
        <template v-if="customerDetail.toiletList.length">
          <van-cell>
            <div
              class="house_add"
              v-for="(item, index) in customerDetail.toiletList"
              :key="index"
            >
              <div class="top">
                <div class="title">
                  卫生间<span v-if="customerDetail.toiletList.length > 1">{{
                    roomNameList[index]
                  }}</span><span style="font-size:8px;">【{{ item.toiletFlag ? "独卫" : "公共" }}】</span>
                </div>
               
                <div>面积：{{ item.acreage }}m²</div>
              </div>

              <div class="img_upload" v-if="item.fileList.length">
                <van-uploader v-model="item.fileList" :show-upload="false" />
              </div>
            </div>
          </van-cell>
        </template>

        <!-- 厨房 -->
        <template v-if="customerDetail.kitchenList.length">
          <van-cell>
            <div
              class="house_add"
              v-for="(item, index) in customerDetail.kitchenList"
              :key="index"
            >
              <div class="top">
                <div class="title">
                  厨房<span v-if="customerDetail.kitchenList.length > 1">{{
                    roomNameList[index]
                  }}</span>
                </div>

                <div>面积：{{ item.acreage }}m²</div>
              </div>

              <div class="img_upload" v-if="item.fileList.length">
                <van-uploader v-model="item.fileList" :show-upload="false" />
              </div>
            </div>
          </van-cell>
        </template>
        <!-- 阳台 -->
         <template v-if="customerDetail.balconyList.length">
          <van-cell>
            <div
              class="house_add"
              v-for="(item, index) in customerDetail.balconyList"
              :key="index"
            >
              <div class="top">
                <div class="title">
                  阳台<span v-if="customerDetail.balconyList.length > 1">{{
                    roomNameList[index]
                  }}</span>
                </div>

                <div>面积：{{ item.acreage }}m²</div>
              </div>

              <div class="img_upload" v-if="item.fileList.length">
                <van-uploader v-model="item.fileList" :show-upload="false" />
              </div>
            </div>
          </van-cell>
        </template>
        <!-- 户型图 -->
        <template v-if="customerDetail.layoutList.length">
          <van-cell>
            <div
              class="house_add"
              v-for="(item, index) in customerDetail.layoutList"
              :key="index"
            >
              <div class="top">
                <div class="title">户型图</div>
              </div>

              <div class="img_upload" v-if="item.fileList.length">
                <van-uploader v-model="item.fileList" :show-upload="false" />
              </div>
            </div>
          </van-cell>
        </template>
        <van-empty v-else description="暂无数据" />
      </van-tab>
      <van-tab title="施工宝" id="jointOrderConstruct">
        <template v-if="customerDetail.constructionCustomer">
           <van-cell title="总计" style="font-weight: bold" :value="customerDetail.constructionCustomer.totalPrice + '元'" />
           <div class="construct_list">
              <div class="top">
                <ul style="display: flex; justify-content: space-between; width: 100%">
                  <li>施工项</li>
                  <li>类型</li>
                  <li style="flex: 1">单价</li>
                  <li>数量</li>
                  <li>备注</li>
                </ul>
              </div>
              <div class="list">
                <ul style="width：100%">
                  <li
                    
                    v-for="(item, index) in customerDetail.constructionCustomer.itemList"
                    :key="index"
                    style="display: flex; justify-content: space-between"
                  >
                    <span>{{ item.projectName }}</span>
                    <span>{{
                      item.priceType == null ? "" : item.priceType > 1 ? "修补" : "新增"
                    }}</span>
                    <span style="flex: 1"
                      >{{
                        item.price
                      }}{{ item.priceType ? item.priceUnit : "" }}</span
                    >
                    <span>{{ item.count }}</span>
                    <span>{{ item.remark }}</span>
                  </li>
                </ul>
              </div>
           </div>
        </template>
        <van-empty v-else description="暂无数据" />
      </van-tab>
      <van-tab title="审批记录">
        <van-steps direction="vertical" :active="0" active-color="#FD7E2D" active-icon="more" inactive-icon="checked" v-if="trackRecordList">
            <van-step v-for="item in trackRecordList" :key="item.id">
                <!-- 开始 -->
                <div v-if="item.taskStartEndType == 1">
                    <div v-for="(item1,index1) in item.actors" :key="index1">
                        <h4>{{item1.actorName}}</h4>
                        <p v-if="item.actorTime">发起时间：{{item.actorTime}}</p>
                    </div>
                </div>
                <!-- 审批 -->
                <div v-else-if="item.taskType == 1">
                    <div v-for="(item1,index1) in item.actors" :key="index1">
                        <h4>{{item1.actorName}}</h4>
                        <p v-if="item1.approvalStatus">审批结果：{{approvalStatusList[item1.approvalStatus -1]}}</p>
                        <p v-if="item1.remark">审批意见：{{item1.remark}}</p>
                        <p v-if="item1.approvalTime">处理时间：{{item1.approvalTime}}</p>
                        <p v-if="item1.createTime">到达时间：{{item1.createTime}}</p>
                    </div>
                </div>
                <!-- 抄送 -->
                <div v-else-if="item.taskType == 2">
                    <div>
                        <h4>
                            <span v-for="(item1,index1) in item.actors" :key="index1">
                                <span v-if="index1!=0">/</span>
                                {{item1.actorName}}
                            </span>
                        </h4>
                        <p v-if="item.actors[0]?item.actors[0].createTime:''">到达时间：{{item.actors[0]?item.actors[0].createTime:''}}</p>
                    </div>
                </div>
                <!-- 结束 -->
                <div v-else>结束</div>
                <!-- <h4>
          <span v-for="(item1,index1) in item.actors" :key="index1">
            <span v-if="index1!=0">/</span>
            {{item1.actorName}}
          </span>
        </h4>
        <p v-if="item.actors[0]?item.actors[0].createTime:''">到达时间：{{item.actors[0]?item.actors[0].createTime:''}}</p>-->
            </van-step>
        </van-steps>
        <van-empty v-else description="暂无数据" />
      </van-tab>
    </van-tabs>
    </div>
  

    <div class="btn" v-if="!$route.query.type">
      <!-- 我的客户 -->
      <a class="font4" :href="'tel:' + customerDetail.phone">
        <van-button type="primary">拨打电话</van-button>
      </a>

      <van-button
        v-if="
          $store.state.buttonAuth.indexOf('crm_JointOrderCustomerFollow') >
            -1 && customerDetail.ownerId && customerDetail.belongType!=1
            && (customerDetail.approvalStatus ==1 || customerDetail.approvalStatus == 3)
        "
        class="font4"
        type="primary"
        @click="
          $router.push({
            path: 'jointOrderAFollow',
            query: {
              id: customerDetail.id,
              status: customerDetail.status,
              lastStatus: customerDetail.lastStatus,
            },
          })
        "
        >添加跟进</van-button
      >
        <van-button
        v-if="$store.state.buttonAuth.indexOf('crm_jointOrderTransfer') > -1  && customerDetail.ownerId && customerDetail.belongType!=1"
        class="font4"
        type="primary"
        @click="
          $router.push({
            path: 'jointOrderATransfer',
            query: { id: customerDetail.id },
          })
        "
        >转让</van-button
      >
      <van-button v-if="($store.state.buttonAuth.indexOf('crm_jointOrderCreateUpdate') > -1) 
        &&(customerDetail.status == 103 ||customerDetail.status == 105)&&
         customerDetail.ownerId && 
        customerDetail.approvalStatus!=2" 
        class="font4"
        type="primary"
        @click="jointOrderAExplore()"
        >实勘</van-button
      >
      <!-- zhuanrang
      &&
          customerDetail.customerBelongType == 1 &&
          customerDetail.isReceipt == 1 -->
    

      <van-button
        v-if="
         $store.state.buttonAuth.indexOf('crm_jointOrderGrap') > -1 && !customerDetail.ownerId  && !(customerDetail.status == 108 || customerDetail.status == 107 || customerDetail.status == 106)"
        class="font1"
        type="primary"
        block
        @click="grap"
        >抢单</van-button
      >
     <van-button
        v-if="
         $store.state.buttonAuth.indexOf('crm_jointOrderConstruct') > -1
          &&(customerDetail.status == 105) && customerDetail.ownerId && 
        customerDetail.decorationType  && 
        customerDetail.approvalStatus!=2
        "
        class="font1"
        type="primary"
        block
        @click="jointOrderConstruct()"
        >施工宝</van-button
      >
      <van-button
        v-if="
         $store.state.buttonAuth.indexOf('crm_jointOrderSubmit') > -1
        &&(customerDetail.status == 105) &&customerDetail.constructionCustomer && 
        customerDetail.approvalStatus!=2  && customerDetail.ownerId
        "
        class="font1"
        type="primary"
        block
        @click="jointOrderSubmit"
        >提交</van-button
      >
     <!-- <van-button 
       type="primary"
       @click="$router.push({path:'approval',
       query:{businessId:customerDetail.id}})">查看审批</van-button> -->
      <!-- 接单 -->
      <!-- <van-button
        v-if="
          $store.state.buttonAuth.indexOf('crm_receiveCustomer') > -1 &&
          customerDetail.customerBelongType == 1 &&
          customerDetail.isReceipt == 0
        "
        class="font1"
        type="primary"
        block
        @click="receipt"
        >接单</van-button
      >

      <van-button
        v-if="$store.state.buttonAuth.indexOf('crm_customerFTransfer') > -1"
        class="font3"
        type="primary"
        @click="
          $router.push({
            path: 'customerTransfer',
            query: { id: customerDetail.id, from: '1' },
          })
        "
        >强制转让</van-button
      > -->
    </div>
    <!-- 获取客户弹框 -->
    <van-dialog
      v-model="showGet"
      title="获取客户"
      show-cancel-button
      :overlay="false"
      :before-close="getBefore"
    >
      <van-form ref="formGet" input-align="center">
        <van-field
          readonly
          clickable
          name="sotreId"
          :value="getQuery.name"
          placeholder="选择门店"
          @click="showStore = true"
          :rules="[{ required: true, message: '请选择门店' }]"
        />
      </van-form>
    </van-dialog>
    <!-- 门店 -->
    <van-popup v-model="showStore" position="bottom">
      <van-picker
        show-toolbar
        :columns="storeList"
        value-key="name"
        @confirm="
          (item) => {
            getQuery = item;
            showStore = false;
          }
        "
        @cancel="showStore = false"
      />
    </van-popup>
      <!-- 审批 -->
    <van-steps
      direction="vertical"
      :active="0"
      active-color="#FD7E2D"
      active-icon="more"
      inactive-icon="checked"
      v-if="type == 1"
    >
      <van-step v-for="item in trackRecordList" :key="item.id">
        <!-- 开始 -->
        <div v-if="item.taskStartEndType == 1">
          <div v-for="(item1, index1) in item.actors" :key="index1">
            <h4>{{ item1.actorName }}</h4>
            <p v-if="item.actorTime">发起时间：{{ item.actorTime }}</p>
          </div>
        </div>
        <!-- 审批 -->
        <div v-else-if="item.taskType == 1">
          <div v-for="(item1, index1) in item.actors" :key="index1">
            <h4>{{ item1.actorName }}</h4>
            <p v-if="item1.approvalStatus">
              审批结果：{{ approvalStatusList[item1.approvalStatus - 1] }}
            </p>
            <p v-if="item1.remark">审批意见：{{ item1.remark }}</p>
            <p v-if="item1.approvalTime">处理时间：{{ item1.approvalTime }}</p>
            <p v-if="item1.createTime">到达时间：{{ item1.createTime }}</p>
          </div>
        </div>
        <!-- 抄送 -->
        <div v-else-if="item.taskType == 2">
          <div>
            <h4>
              <span v-for="(item1, index1) in item.actors" :key="index1">
                <span v-if="index1 != 0">/</span>
                {{ item1.actorName }}
              </span>
            </h4>
            <p v-if="item.actors[0] ? item.actors[0].createTime : ''">
              到达时间：{{ item.actors[0] ? item.actors[0].createTime : "" }}
            </p>
          </div>
        </div>
        <!-- 结束 -->
        <div v-else>结束</div>
        <!-- <h4>
          <span v-for="(item1,index1) in item.actors" :key="index1">
            <span v-if="index1!=0">/</span>
            {{item1.actorName}}
          </span>
        </h4>
        <p v-if="item.actors[0]?item.actors[0].createTime:''">到达时间：{{item.actors[0]?item.actors[0].createTime:''}}</p>-->
      </van-step>
    </van-steps>
    <van-form
      ref="form"
      label-width="110px"
      input-align="left"
      v-if="
        $route.query.type == 1 && type == 1 && trackRecordList[0].status != 5
      "
    >
      <van-field label="审批意见" :border="false" />
      <van-field
        v-model="formData.remark"
        rows="2"
        autosize
        type="textarea"
        maxlength="50"
        placeholder="请输入审批意见"
        show-word-limit
        :rules="[{ required: true, message: '请输入审批意见' }]"
      />
    </van-form>
    <div v-if="$route.query.type" style="height: 1.2rem"></div>
    <div class="btn" v-if="$route.query.type">
      <van-button v-if="type == 0" @click="type = 1" type="primary"
        >审批</van-button
      >
      <van-button v-if="type == 1" @click="type = 0" type="primary"
        >详情</van-button
      >
      <van-button
        block
        type="primary"
        v-if="
          $route.query.type == 1 && type == 1 && trackRecordList[0].status != 5
        "
        :loading="saveLoad"
        :disabled="saveLoad"
        @click="submit(2)"
        >驳回</van-button
      >
      <van-button
        block
        type="primary"
        v-if="
          $route.query.type == 1 && type == 1 && trackRecordList[0].status != 5
        "
        :loading="saveLoad"
        :disabled="saveLoad"
        @click="submit(1)"
        >同意</van-button
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
   requestWorkflowDetail,
  requestJointOrderCustomerDetail,
  requestCustomerGrap,
  requestJointOrderCustomerGrap, //抢单
  requestPCStore,
  requestCustomerGet,
  requestReceiveTransfer,
  requestJointOrderGrabbing,
    requestWorkflowSubmit,
  requestJointOrderSubmit,
  changeCompany, //钉钉消息进入详情页需切换公司 获取对应按钮权限
  requestButtomAuth,
    requestWorkflowDetail1,
} from "@/api";
import { getCountdown, getMinuteInteger } from "@/utils";
export default {
  name: "jointOrderADetail",
  data() {
    return {

      active: 0,
      customerDetail: {
        roomList: [
         
        ],
        toiletList:[],
        hallList:[],
        kitchenList:[],
        layoutList:[],
        balconyList:[]
      },
      checkBoxList: [
        { label: "优化间", value: 1, isCheck: 0 },
        { label: "独立阳台", value: 2, isCheck: 0 },
        { label: "飘窗", value: 3, isCheck: 0 },
        { label: "独卫", value: 4, isCheck: 0 },
      ],
      toWardsList: {
        S: "朝南",
        E: "朝东",
        W: "朝西",
        N: "朝北",
      },
      countdown: [0, 0, 0, 0],
       //房间名称
      roomNameList: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      //获取客户
      getQuery: {
        name: "",
        id: "",
      },
      type: 0, //切换0.详情/1.审批
           saveLoad: false,
      trackRecordList: [],
      formData: {
        remark: "",
      },
      showGet: false,
      showStore: false,
      storeList: [],
      timer: "",
    };
  },
  computed: {
    ...mapState([
      "idTypeList",
      "destineList",
      "payList",
      "contractList",
      "customerList",
      "contactList",
       "approvalStatusList",
    ]),
    
   
     decorationBeforeName() {
      // if (
      //   this.customerDetail.chamberNumOld ||
      //   this.customerDetail.hallNumOld ||
      //   this.customerDetail.toiletNumberOld ||
      //   this.customerDetail.kitchenNumOld ||
      //   this.customerDetail.balconyNumOld
      // ) {
      //   // this.DecorationBeforeList[0].defaultIndex = this.customerDetail.chamberNumOld
       
      // } else {
      //   return "";
      // }
       return `${this.customerDetail.chamberNumOld ? this.customerDetail.chamberNumOld : "0"} 室 ${
          this.customerDetail.hallNumOld ? this.customerDetail.hallNumOld : "0"
        } 厅 ${
          this.customerDetail.toiletNumberOld ? this.customerDetail.toiletNumberOld : "0"
        } 卫 ${this.customerDetail.kitchenNumOld ? this.customerDetail.kitchenNumOld : "0"} 厨 ${
          this.customerDetail.balconyNumOld ? this.customerDetail.balconyNumOld : "0"
        } 阳台`;
    },
     decorationAfterName() {
        return `${this.customerDetail.chamberNum ? this.customerDetail.chamberNum : "0"} 室 ${
          this.customerDetail.hallNum ? this.customerDetail.hallNum : "0"
        } 厅 ${this.customerDetail.toiletNumber ? this.customerDetail.toiletNumber : "0"} 卫 ${
          this.customerDetail.kitchenNum ? this.customerDetail.kitchenNum : "0"
        } 厨 ${this.customerDetail.balconyNum ? this.customerDetail.balconyNum : "0"} 阳台`;
      // if (
      //   this.customerDetail.chamberNum ||
      //   this.customerDetail.hallNum ||
      //   this.customerDetail.toiletNumber ||
      //   this.customerDetail.kitchenNum ||
      //   this.customerDetail.balconyNum
      // ) {
       
      // } else {
      //   return "";
      // }
    },
     total: function () {
      // console.log('计算属性', this.message)
      let totalPrice = 0;
      this.customerDetail.constructionCustomer.itemList.forEach((item, index) => {
        if (item.priceType < 2) {
          totalPrice += item.addPrice * item.count;
        } else {
          totalPrice += item.repairPrice * item.count;
        }
        this.totalPrice = totalPrice;
      });
      return totalPrice + " 元";
    },
  },
  created() {
    // this.$nextTick(function(){
    //     this.getDetail();
    //   });
    this.getDetail();
    this.getPCStore();
    if (this.$route.query.type) {
            //待办进入
            this.getWorkflow();
        }
  },
  mounted() {},
  methods: {
    getDetail() {
      const toast1 = this.$toast.loading({
        forbidClick: true,
        duration: 0,
        message: "加载中...",
      });
      requestJointOrderCustomerDetail(this.$route.query.id)
        .then((res) => {
              console.log(res);
          if(res.data.ownerId == 0 ){
               changeCompany({ companyId: res.data.companyId }).then(
                (res) => {
                  this.$store.dispatch("resetAll", res.data);
                  requestButtomAuth().then((res) => {
                    this.$store.commit("SET_BUTTON", res.data || []);
                  });
                }
              );
          }
          this.customerDetail = res.data;
          this.filterRoomList(this.customerDetail.roomList);
          this.filterRoomList(this.customerDetail.toiletList);
          this.filterRoomList(this.customerDetail.hallList);
          this.filterRoomList(this.customerDetail.kitchenList);
          this.filterRoomList(this.customerDetail.layoutList);
          this.filterRoomList(this.customerDetail.balconyList);
        
          this.getQuery.id = this.customerDetail.storeId;
          if (res.data.statusExpireTime) {
            if (
              new Date(res.data.statusExpireTime.replace(/-/g, "/")) >
              new Date()
            ) {
              let date = getMinuteInteger(res.data.statusExpireTime);
              this.countdown = getCountdown(date);
              this.timer = setInterval(() => {
                this.countdown = getCountdown(date);
                if (
                  this.countdown[0] / 1 == 0 &&
                  this.countdown[1] / 1 == 0 &&
                  this.countdown[2] / 1 == 0 &&
                  this.countdown[3] / 1 == 0
                ) {
                  //客户过期
                  clearInterval(this.timer);
                  requestJointOrderCustomerDetail(this.$route.query.id).then(
                    (res1) => {
                      this.customerDetail = res.data;
                      this.getQuery.id = this.customerDetail.storeId;
                    }
                  );
                }
              }, 1000);
            }
          }
          toast1.clear();
        })
        .catch((err) => {
          toast1.clear();
        });
    },
    // 点击实勘前校验
    jointOrderAExplore(){
        if(this.customerDetail.constructionCustomer){
           this.$dialog.confirm({
                          title: "提示",
                          message: "重新实勘并保存会清空施工宝，是否继续操作?",
                          confirmButtonText: "确认",
                          cancelButtonText: "取消",
           }).then(()=>{
              this.$router.push({
                path: 'jointOrderAExplore',
                query: { id: this.customerDetail.id },
              })
           })           
          //  this.$toast.fail("该客户未实名认证,请先去个人中心进行实名认证");
        }else{
          this.$router.push({
            path: 'jointOrderAExplore',
            query: { id: this.customerDetail.id },
          })
        }
    },
    // 点击施工宝前校验
    jointOrderConstruct(){
        if(this.customerDetail.expectPrice == 0){
            this.$toast.fail("预计出租价格为0,请在实勘页面重新获取");
            return false
        }
        if(this.customerDetail.expectPrice == null){
             this.$toast.fail("预计出租价格不存在,请在实勘页面重新获取");
             return false
        }
        if(!this.customerDetail.communityId){
           this.$toast.fail("小区信息不存在,请在实勘页面填写");
           return false
        }
        if(!this.customerDetail.buildingNo){
             this.$toast.fail("请在实勘页面补充楼号");
             return false
        } 
        if(!this.customerDetail.unitNo){
             this.$toast.fail("请在实勘页面补充单元号");
             return false
        } 
        if(!this.customerDetail.roomNo){
             this.$toast.fail("请在实勘页面补充房间号");
             return false
        } 
        this.$router.push({
                path: '/jointOrderConstruct',
                query: { id: this.customerDetail.id,decorationType:this.customerDetail.decorationType },
        })
    },
   //查流程
    getWorkflow() {
      //审批待办
      requestWorkflowDetail1(this.$route.query.agentId).then(res => {
        console.log(res)
      this.trackRecordList = res.data ? res.data : [];
      this.trackRecordList[0].status == 5
      ? (this.type = 1)
       : (this.type = 0);
                // this.loading = false;
      });         
    },
    filterRoomList(data) {
      data.forEach((item, index) => {
        item.fileList = [];
        for (let i = 0; i < item.imageUrls.length; i++) {
          item.fileList.push({
            url: item.imageUrls[i],
            deletable: false,
          });
        }
      });
    },
    //门店下拉
    getPCStore() {
      requestPCStore().then((res) => {
        res.data.forEach((d) => {
          d.text = d.name;
          d.value = d.id;
        });
        this.storeList = res.data;
      });
    },
    //签约
    goContract() {
      if (this.customerDetail.isVerified != 1) {
        this.$toast.fail("该客户未实名认证,请先去个人中心进行实名认证");
        return;
      }
      this.$router.push({
        path: "contractAdd",
        query: { customerId: this.customerDetail.id },
      });
    },
    //抢单
    grap() {
     
      requestJointOrderGrabbing({
          phone:this.customerDetail.phone,
          id:this.customerDetail.id
      })
          .then((res) => {
              if (res.data) {
                  this.$dialog
                      .confirm({
                          title: "提示",
                          message: "系统存在其他客户与该客户手机号相同，请确认是否抢单",
                          confirmButtonText: "抢单",
                          cancelButtonText: "取消",
                      })
                      .then(() => {
                        requestJointOrderCustomerGrap(this.customerDetail.id).then((res) => {
                                this.$toast.success({
                                  message:"抢单成功",
                                  duration:1500,
                                  onOpened:()=>{
                                      console.log("test")
                                      this.getDetail()
                                  }
                                });
                            });
                          // on confirm
                      })
                      .catch(() => {
                          // on cancel
                      });
                  resolve(true);
              }else{
                     requestJointOrderCustomerGrap(this.customerDetail.id).then((res) => {
                                  this.$toast.success({
                                  message:"抢单成功",
                                  duration:1500,
                                  onOpened:()=>{
                                      console.log("test")
                                      this.getDetail()
                                  }
                                });
                            });
              }
          })
          .catch((err) => {
            //   this.saveLoad = false;
          });
      //  requestJointOrderPhoneRepeat(val)
      //         .then((res) => {

      //             if (res.data && res.data != this.form.id) {
      //                 this.showCity = false;
      //                 this.$dialog
      //                     .alert({
      //                         title: "提醒",
      //                         message: "系统已存在同一手机号客户",
      //                     })
      //                     .then(() => {
      //                          resolve(true);
      //                     })

      //             } else {
      //                 resolve(true);
      //             }
      //         })
      //         .catch((err) => {

      // });
    
    },
    //获取客户
    getBefore(action, done) {
      if (action === "confirm") {
        this.$refs.formGet
          .validate()
          .then((valid) => {
            requestCustomerGet(this.customerDetail.id, this.getQuery.id)
              .then((res) => {
                this.$toast({
                  type: "success",
                  message: "获取成功!",
                  // forbidClick: true,
                  onClose: () => {},
                });
                this.getQuery = {};
                this.getDetail();
                done();
              })
              .catch((err) => {
                done(false);
              });
          })
          .catch((err) => {
            done(false);
          });
      } else {
        done();
      }
    },
    //接单
    receipt() {
      this.$dialog.confirm({
        message: "确认接单？",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, done) => {
          if (action === "confirm") {
            requestReceiveTransfer(this.$route.query.id)
              .then((res) => {
                this.$toast.success({
                  message: "接单成功",
                  // forbidClick: true,
                  onClose: () => {},
                });
                this.getDetail();
                done();
              })
              .catch((err) => {
                done(false);
              });
          } else {
            done();
          }
        },
      });
    },
    jointOrderSubmit() {
            this.$dialog.confirm({
                title: "提示",
                message: "确认提交",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                beforeClose: (action, done) => {
                    if (action === "confirm") {
                        requestJointOrderSubmit(
                            this.customerDetail.id
                        )
                            .then(res => {
                                done();
                                this.$toast({
                                    type: "success",
                                    message: "提交成功!",
                                    // forbidClick: true,
                                    onClose: () => {}
                                });
                                this.getDetail();
                            })
                            .catch(err => {
                                done(false);
                            });
                    } else {
                        done();
                    }
                }
            });
    },
    submit(type) {
      let param = {
        agentId: this.$route.query.agentId,
        orderId: this.$route.query.orderId,
        approvalStatus: type,
        remark: this.formData.remark,
      };
      if (type == 1) {
        //同意
        this.$dialog.confirm({
          title: "提示",
          message: type == 1 ? "确定同意吗？" : "确定驳回吗？",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          beforeClose: (action, done) => {
            if (action === "confirm") {
              this.saveLoad = true;
              requestWorkflowSubmit(param)
                .then((res) => {
                  this.$toast({
                    type: "success",
                    message: "审批成功!",
                    // forbidClick: true,
                    onClose: () => {},
                  });
                  this.getWorkflow();
                  this.saveLoad = false;
                  done();
                })
                .catch((err) => {
                  this.saveLoad = false;
                  done(false);
                });
            } else {
              done();
            }
          },
        });
      } else {
        //驳回
        this.$refs["form"].validate().then((valid) => {
          this.$dialog.confirm({
            title: "提示",
            message: type == 1 ? "确定同意吗？" : "确定驳回吗？",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            beforeClose: (action, done) => {
              if (action === "confirm") {
                this.saveLoad = true;
                requestWorkflowSubmit(param)
                  .then((res) => {
                    this.$toast({
                      type: "success",
                      message: "审批成功!",
                      // forbidClick: true,
                      onClose: () => {},
                    });
                    this.getWorkflow();
                    this.saveLoad = false;
                    done();
                  })
                  .catch((err) => {
                    this.saveLoad = false;
                    done(false);
                  });
              } else {
                done();
              }
            },
          });
        });
      }
    },
    onClick(name,title){
      console.log(name,title)
      if(name == 4){
          requestWorkflowDetail({
                    businessId: this.customerDetail.id
                }).then(res => {
                    if(res.data){
                        this.trackRecordList = res.data ? res.data : [];
                    this.loading = false;
                    }else{
                       this.trackRecordList = null
                    this.loading = false;
                    }
                }).catch(err=>console.log(err))
      }
    }
   },
     //审批提交
   
  destroyed() {
    clearInterval(this.timer); // 清除定时器
    this.timer = null;
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
#jointOrderADetail {
  .colorC {
    color: $colorC;
  }
  .fail-color {
    color: $fail-color;
  }
  .theme-color {
    color: $theme-color;
  }
  .titlee {
    padding: 0.2rem 0.42667rem;
    background-color: #fff;
    font-size: 0.3rem;
    display: flex;
    justify-content: space-between;
    position: relative;
    &::after {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0;
      bottom: 0;
      left: 0;
      border-bottom: 0.02667rem solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
  }
  .clock {
    i {
      vertical-align: middle;
    }
  }
  .content {
    background-color: #fff;
    display: flex;
    // border-radius: 0.2rem;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    &.nowarp {
      flex-wrap: nowrap;
    }
    .inlineB {
      flex: 1;
      padding: 0.2rem 0;
      width: 33.3%;
      min-width: 33.3%;
      max-width: 33.3%;
      position: relative;
      p.l {
        line-height: 0.7rem;
        height: 0.7rem;
      }
      &:not(:last-child)::after {
        height: 50%;
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        border-right: 0.02667rem solid #ebedf0;
        z-index: 99;
      }
    }
  }
  .tabs {
    /deep/.van-tabs__wrap {
      margin: 0.2rem 0;
    }
    /deep/.van-tabs__content {
      height: calc(100vh - 5.5rem);
      overflow: scroll;
    }
    .van-steps {
      text-align: left;
      padding-left: 2rem;
      /deep/.van-step__title {
        padding-left: 0.3rem;
        p {
          padding-top: 0.2rem;
        }
      }
    }
    .body {
      // padding-top: 0.001rem;
      font-size: 0.35rem;
      margin-top: 0.3rem;
      .card {
        background: #fff;
        margin: 0.3rem;
        border-radius: 0.2rem;
        color: $color9;
        padding: 0.2rem 0;
        // margin: 0.2rem 0;
        p {
          text-align: left;
          display: flex;
          justify-content: space-between;
          padding: 0 0.4rem;
          line-height: 0.8rem;
          // height: 0.8rem;
          .title {
            font-size: 0.35rem;
            font-weight: 600;
            height: auto;
            color: #000;
            // span {
            //     max-width: 4.5rem;
            //     vertical-align: top;
            //     overflow: hidden;
            //     display: inline-block;
            //     height: auto;
            //     text-overflow: ellipsis;
            // }
            // .ellipsis {
            //     white-space: nowrap;
            // }
          }
          .big {
            font-size: 0.4rem;
          }
        }
      }
      > .card:first-child {
        margin-top: 0;
      }
      .theme-color {
        color: $theme-color;
      }
    }
  }
  .btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
      // margin-left: -1px;
      border: none;
      border-radius: 0;
      flex: 1;
      padding: 0%;
      &:not(:last-child)::after {
        height: 50%;
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        border-right: 0.02667rem solid #ebedf0;
        z-index: 99;
      }
    }
    a {
      color: #fff;
      flex: 1;
      button {
        width: 100%;
      }
      position: relative;
      &::after {
        height: 50%;
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        border-right: 0.02667rem solid #ebedf0;
        z-index: 99;
      }
    }
    .font4 {
      width: 2.7rem;
    }
    .font3 {
      width: 1.8rem;
    }
    // .font5 {
    //   width: 51%;
    // }
    .font1 {
      width: 100%;
      margin-left: 0;
    }
  }
}
.success {
  color: $success-color;
  .van-button {
    border-radius: 1rem;
    transform: translateY(-0.1rem);
  }
}
.fail {
  color: $fail-color;
  .van-button {
    border-radius: 1rem;
    transform: translateY(-0.1rem);
  }
}
.imgBody {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  background-color: #fff;
  padding: 0.5rem 0.2rem 0;
  border-radius: 0.2rem;
  .imgCard {
    margin: 0 0.1rem;
    .text {
      line-height: 0.8rem;
    }
  }
}
.house_add {
  text-align: initial;
  background: #fff;
  color: #323233;
  font-size: 0.32rem;
  .title {
    font-size: 14px;
  }
  /deep/.van-checkbox__label--disabled {
    color: #323233 !important;
  }
 /deep/.van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon {
    color: #ffffff;
    background-color: #fd7e2d;
    border-color: #fd7e2d;
  }
  .options {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }
  .option {
    width: 33.3%;
    margin: 0.18rem 0;
    display: flex;
  }
  .top {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    margin-bottom: 0.15rem;
    div {
      width: 33.33%;
      display: flex;
      &:nth-of-type(2) {
        justify-content: center;
      }
      &:nth-of-type(3) {
        justify-content: flex-end;
        margin-right: 0.54rem;
      }
    }
  }
  /deep/.van-uploader__preview {
    width: 2.88rem;
    height: 2.88rem;
    margin: 0 0.1rem;
  }
  /deep/.van-uploader__preview:nth-of-type(3) {
    margin-right: 0;
  }
  /deep/.van-uploader__preview-image {
    width: 100%;
    height: 2.8rem;
  }

}
#jointOrderConstruct {
  .btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
      margin-left: -1px;
      border: none;
      border-radius: 0;
      flex: 1;
      &:not(:last-child)::after {
        height: 50%;
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        border-right: 0.02667rem solid #ebedf0;
        z-index: 99;
      }
    }
  }
  .construct_list {
    background: #fff;

    .top {
      padding: 0.26667rem 0.42667rem;
      position: relative;
    }
    .top::after {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0rem;
      bottom: 0;
      left: 0rem;
      border-bottom: 0.02667rem solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
    .top li {
      width: 18%;
      position: relative;
    }
    .top li:nth-of-type(1) {
      // width:30%;
      //  flex:1;
      text-align: left;
    }
    .list li {
      padding: 0.26667rem 0.42667rem;
      position: relative;
    }
    .list li:after {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0rem;
      bottom: 0;
      left: 0rem;
      border-bottom: 0.02667rem solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
    .list li span {
      width: 18%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .list li span:nth-of-type(1) {
      // width:30%;
      // flex:1;
      text-align: left;
    }
  }
}
.van-steps {
  text-align: left;
  padding-left: 2rem;
  /deep/.van-step__title {
    padding-left: 0.3rem;
    p {
      padding-top: 0.2rem;
    }
  }
}
.success {
  color: $success-color;
  .van-button {
    border-radius: 1rem;
    transform: translateY(-0.1rem);
  }
}
.fail {
  color: $fail-color;
  .van-button {
    border-radius: 1rem;
    transform: translateY(-0.1rem);
  }
}
</style>
